import { LoadablePaint } from '@confluence/loadable';

export const SiteHomepageRedirectLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SiteHomepageRedirect" */ '../src/SiteHomepageRedirect.tsx'
			)
		).SiteHomepageRedirect,
});
